'use strict'

import { combineReducers } from 'redux';
import update from 'immutability-helper';

import * as types from './types';

const byId = (state = {}, action) => {

	let place;

	switch (action.type) {

		case types.CREATE_PLACE_COMPLETED:

			({ place } = action.data);

			return {
				...state,
				[ place._id ]: place,
			};
			
		default:
			return state;
	}
};

const allIds = (state = [], action) => {

	let place;

	switch (action.type) {

		case types.CREATE_PLACE_COMPLETED:

			({ place } = action.data);

			return [ ...new Set([ ...state, place._id ]) ];

		default:
			return state;
	}
};

export default combineReducers({
    byId,
    allIds,
});
